import React from "react";
import injectSheet from "react-jss";
import NumberFormat from "react-number-format";
import { Image, InfoButton } from "../../";

const BudgetSliderLegend = (props) => {
	const {
		classes,
		budget: {
			config: { currency },
			handle: { hasBlock },
		},
		budgetOverview: { auxiliaries, plotPrice, total },
	} = props;

	return (
		<div className={`${classes.legendContainer}`}>
			<React.Fragment>
				<h4>Aufteilung Gesamt-Budget</h4>
				<ul>
					<li>
						<div className={`${classes.element} plot`}>
							<div className={`${classes.elementImage}`}>
								<Image src="images/static/plot.svg" />
							</div>
							<span className={`${classes.elementTitle}`}>Bauland: </span>
							{(!hasBlock && (
								<span className={`${classes.elementCost}`}>vorhanden</span>
							)) || (
								<NumberFormat
									className={`${classes.elementCost}`}
									displayType="text"
									value={plotPrice}
									thousandSeparator="'"
									suffix={` ${currency}`}
								/>
							)}

							<InfoButton
								modalText="Die Preise für Bauland sind sehr individuell in der Schweiz. Unser Berechnungsmodell bezieht sich auf die Erfahrungswerte der letzten Jahre. Die Höhe des Baulandpreises beträgt mindestens einen Drittel Ihres brutto Budgets und nimmt mit der Höhe des Budgets linear ab."
								modalTitle="Bauland"
								tip="info"
							/>
						</div>
					</li>
					<li>
						<div className={`${classes.element} auxiliaries`}>
							<div className={`${classes.elementImage}`}>
								<Image src="images/static/auxiliaries.svg" />
							</div>
							<span className={`${classes.elementTitle}`}>Nebenkosten: </span>
							<NumberFormat
								className={`${classes.elementCost}`}
								displayType="text"
								value={auxiliaries}
								thousandSeparator="'"
								suffix={` ${currency}`}
							/>
							<InfoButton
								modalText="Zu den Baunebenkosten gehören unter anderem Baugenehmigung, Bauvertragsprüfung, Vermessungskosten, Aushubarbeiten, Erschliessungskosten (Kanalisation, Wasser, Strom, Gas, Telefon, TV), Versicherungen und Bauzinsen. Je nach Lage können Kosten für die Baustrasse, Baumfällung oder Abrissarbeiten dazukommen."
								modalTitle="Nebenkosten"
								tip="info"
							/>
						</div>
					</li>
					<li>
						<div className={`${classes.element} house`}>
							<div className={`${classes.elementImage}`}>
								<Image src="images/static/house.svg" />
							</div>
							<span className={`${classes.elementTitle}`}>Hausbau: </span>
							<NumberFormat
								className={`${classes.elementCost}`}
								displayType="text"
								value={total - plotPrice - auxiliaries}
								thousandSeparator="'"
								suffix={` ${currency}`}
							/>
							<InfoButton
								modalText="Hierbei handelt es sich um das Nettobudget für Ihr zukünftiges Einfamilienhaus (Kubatur in Massivbauweise). Die Kosten werden durch die nachfolgende Konfiguration beeinflusst."
								modalTitle="Hausbau"
								tip="info"
							/>
						</div>
					</li>
				</ul>
			</React.Fragment>
		</div>
	);
};

const styles = (theme) => ({
	legendContainer: {
		height: "140px",
		width: "100%",
		padding: `0px ${theme.sizes.gutter}px`,
		color: theme.colors.secondary_3b,
		"& h4": {
			margin: `0 0 ${theme.sizes.gutter / 4}px 0`,
		},
		"& ul": {
			listStyleType: "none",
			margin: 0,
			padding: 0,
		},
	},
	element: {
		display: "flex",
		alignItems: "center",
		padding: `${theme.sizes.gutter / 4}px 0`,
	},
	elementImage: {
		width: "16px",
		marginRight: "5px",
	},
	elementTitle: {
		marginRight: "5px",
		fontSize: "80%",
		fontWeight: "bold",
	},
	elementCost: {
		marginRight: "5px",
		fontSize: "80%",
	},
});

export default injectSheet(styles)(BudgetSliderLegend);



// WEBPACK FOOTER //
// ./src/modules/budget/components/budgetSliderLegend.jsx